import axios from 'axios';
import isEmpty from 'lodash.isempty';
import { JSON_HEADERS, HTTP_RESPONSE_CODE } from '../constants/shared/ApiConstants';
import KeycloakClient from './clients/shared/KeycloakClient';

const axiosInstance = axios.create({
    headers: JSON_HEADERS,
    withCredentials: true,
});

axiosInstance.interceptors.response.use(response => {
    if (response.status === HTTP_RESPONSE_CODE.NO_CONTENT) {
        return [];
    }
    if (
        response.status === HTTP_RESPONSE_CODE.CREATED &&
        !isEmpty(response.headers['content-location'])
    ) {
        return response.headers['content-location'];
    }
    return response.data;
});

axiosInstance.interceptors.request.use(requestConfig =>
    KeycloakClient.updateToken()
        .then(() => ({
            ...requestConfig,
            headers: {
                ...requestConfig.headers,
                Authorization: `Bearer ${KeycloakClient.getToken()}`,
            },
        }))
        .catch(KeycloakClient.logout),
);

export default axiosInstance;
